// extracted by mini-css-extract-plugin
export default {"content":"ObjectsContent_content__Cfe0H"};